import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import { onMounted, ref } from 'vue'
import { useAdminAuth } from '@/composables/useAdminAuth'
import InfoPreparingPage from './InfoPreparingPage.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoAccessGate',
  setup(__props) {

const { isAdminLoggedIn, initAdminAuth } = useAdminAuth()
const ready = ref(false)

onMounted(async () => {
  await initAdminAuth()
  ready.value = true
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (ready.value && !_unref(isAdminLoggedIn))
    ? (_openBlock(), _createBlock(InfoPreparingPage, { key: 0 }))
    : (ready.value)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : _createCommentVNode("", true)
}
}

})